import { useEffect, useState } from "react";
import { Observable } from "rxjs";

export const useObservable = <T>(observable : Observable<T>) => {
    const [state, setState] = useState<T>();
  
    useEffect(() => {
      const sub = observable.subscribe(setState);
      return () => sub.unsubscribe();
    }, [observable]);

    useEffect(()=>{
      console.log("useObservable state changed");
      console.log(state);

    },[state])
  
    return state;
};

